import React, { useState } from "react";
import urls from "./urls";
import axios from "axios";
const url = process.env.REACT_APP_BASEURL;
const authToken = process.env.REACT_APP_INTERNAL_AUTH_TOKEN;
// const url = process.env.REACT_APP_LOCAL_URL;
export const request = axios.create({
  baseURL: url,
  headers: {
    Authorization: `Bearer ${authToken}`,
  },
});

interface AxiosResponse<T> {
  success: boolean;
  payload: T;
}

export interface vehicle {
  make: string;
  models?: {
    name: string;
    years?: string[];
  }[];
}

export default function useAPI() {
  const getVehicles = async () => {
    try {
      const { data } = await request.get<AxiosResponse<string[]>>(
        urls.carMakes
      );

      return sortData(data.payload);
    } catch (error) {
      console.error("error", error);
    }
  };

  const getVehicleModels = async (carMake?: string) => {
    if (!carMake) return Promise.resolve([]);
    try {
      // Fetch car models based on carMake
      const { data } = await request.get(
        addParamstourl(urls.carModels, { carMake })
      );

      return sortData(data.payload);
    } catch (error) {
      console.error("error", error);
    }
  };

  const getYearbyModel = async (carMake?: string, carModel?: string) => {
    if (!carMake || !carModel) return Promise.resolve([]);
    try {
      // Fetch car models based on carMake
      const { data } = await request.get(
        addParamstourl(urls.carYears, { carMake, carModel })
      );

      return sortData(data.payload);
    } catch (error) {
      console.error("error", error);
    }
  };

  return {
    getVehicles,
    getYearbyModel,
    getVehicleModels,
  };
}

export const addParamstourl = (url: string, params: Record<string, string>) => {
  let updatedUrl = url;
  Object.keys(params).map((key) => {
    const symbol = updatedUrl.includes("?") ? "&" : "?";
    updatedUrl += `${symbol + key}=${params[key]}`;
  });
  return updatedUrl;
};

const sortData = (data: string[]) => {
  return data.sort((a, b) => {
    return a > b ? 1 : -1;
  });
};
